import { render, staticRenderFns } from "./qz-button.vue?vue&type=template&id=645d3f03&scoped=true&"
import script from "./qz-button.vue?vue&type=script&lang=js&"
export * from "./qz-button.vue?vue&type=script&lang=js&"
import style0 from "./qz-button.vue?vue&type=style&index=0&id=645d3f03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d3f03",
  null
  
)

export default component.exports